import React, { useMemo } from 'react';
import { Meta, useWorkplaceMetaQuery } from '../../../graphql/graphql';

export default function useWorkplaceMeta(workplaceId: string) {
	const workplaceMeta = useWorkplaceMetaQuery({
		id: workplaceId,
	});

	const isHealthPlanBabyForFree = useMemo(() => {
		return workplaceMeta?.currentData?.workplace?.meta?.some(
			(item: Meta | null) => item?.key === 'HealthPlanBabyForFree',
		);
	}, [workplaceMeta]);

	return {
		isHealthPlanBabyForFree,
		workplaceMeta: workplaceMeta?.currentData?.workplace?.meta as Meta[],
		reFetchWorkplaceMeta: workplaceMeta.refetch,
	};
}
